export const ENDPOINT_API = 'https://24tthw7add.execute-api.eu-west-1.amazonaws.com'
export const CLIENT_ID = '3LTkeFQLjbiu0lCdj5IBVHntmrlnqr17'
export const DOMAIN = 'terega.eu.auth0.com'
export const AUDIENCE = 'https://api.terega.fr/vm-manager'
